angular.module('unica_transfer.transfer_controllers')

.controller('TransferEditController', function(
	$rootScope, $scope, $state, $stateParams, TransferEditService
) {

	$scope.pageTitle = 'Modifica Transfer';

	$scope.getTransfer( $stateParams.id );

	$scope.saveTransfer = function () {
		$scope.showLoader();

		TransferEditService
			.update( $scope.transferData )
			.then(function(data) {
				$scope.hideLoader();

				if (!data.error) {
					$scope.showSuccessMsg('Transfer aggiornato con successo!', '');
					$state.go('app.hospitality.transfer_list');
				} else {
					$rootScope.manageError(data);
				}
			});
	};
});